import axios from "axios";
import React, { useEffect, useState } from "react";
import { Badge } from "antd";
import { association } from "../../apis/urls";
import { Card, Text, Grid } from "@nextui-org/react";
import { $ } from "react-jquery-plugin";
import { Link, useNavigate } from "react-router-dom";
import { decode } from "html-entities";




const Cards = () => {

    const [result, setResult] = useState([]);

    const navigate = useNavigate();

    useEffect(()=>{
        $('body').removeClass('sidebar-active').addClass('sidebar-collapsed');
        $('.sidebar-toggler').removeClass('').addClass('toggle-opacity');
        $( ".sidebar-toggler" ).attr('disabled', true)
        selectItems();
    },[])

    const selectItems =async () =>{
        let tokens = localStorage.getItem('association');
        
        var strVale = tokens;
        let arr = strVale.split(',');

        // let length = arr.length;

        AssociationView(arr)

    }


    const AssociationView = (ids) => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const data = {
            ids: ids
        }


        const instance = axios.create({
            baseURL: association+"multiple",
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('', data).then(async res => {
            // console.log(res.data.data)
            setResult(res.data.data)
        });
    }




    return(
        <Grid.Container gap={2} justify="center">
            {result?.map((item, index) =>(
                <Grid xs={4} key={index} >
                    <Card css={{ 
                        $$cardColor: 'linear-gradient(90deg, hsla(276, 91%, 79%, 1) 0%, hsla(254, 74%, 65%, 1) 100%)', 
                        borderRadius:'10px', padding:5}}>
                        <Card.Body style={{height:'130px'}}>
                            <Text h3 css={{ mt: 0 , color:'#fff', fontWeight:900}}>
                                {decode(item.name)}
                            </Text>
                            <Text h5 color="white" css={{ mt: 0 , color:'#000', fontWeight:900}}>
                                {item.sport.name}
                            </Text>
                        </Card.Body>

                        <Grid.Container gap={2} justify="center">
                            <Grid xs={12} onClick={()=>{navigate('/associationview/'+item.id)}} style={{cursor:'pointer'}}>
                                <Card css={{ $$cardColor: "#fff", borderRadius:'10px'}} className="button-select">
                                    <Card.Body>
                                        <Text h6 size={16} color="#fff" css={{ fontWeight:900, textAlign:"center", paddingTop:'5px'}}>
                                            View Profile
                                        </Text>
                                    </Card.Body>
                                </Card>
                            </Grid>
                        </Grid.Container>

                        <Grid.Container gap={2} justify="center">
                            <Grid xs={12} onClick={()=>{navigate('/association_officials/'+item.id)}} style={{cursor:'pointer'}}>
                                <Badge title="Pending officials" size="default" count={item.officials_pending   === '0'?'0':item.officials_pending} >                                                
                                    <Card css={{  borderRadius:'10px'}} className="button-select">
                                        <Card.Body>
                                            <Text h6 size={16} color="white" css={{ mt: 0 , color:'#fff', fontWeight:900, textAlign:"center", paddingTop:'5px'}}>
                                                Officials
                                            </Text>
                                        </Card.Body>
                                    </Card>
                                </Badge>
                            </Grid>
                        </Grid.Container>
                    </Card>
                </Grid>
            ))}
        </Grid.Container>
    )
}


const AssociationSelect =()=>{

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <Cards />
                </div>
            </aside>
        </div>
    )

}

export default AssociationSelect;